import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-lead-created-goal.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'goalLeadCreated';

/**
 * @deprecated This is a legacy icon
 */
export const GoalLeadCreatedIcon = svgIconWrapper(SvgComponent);
